import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpDiscardAccesses, HttpDiscardAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {invalidateAccessesTableOnly, updateAccessStatusInSignatureSheetsCache} from '../cacheUtils'

export const useDiscardAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpDiscardAccessesOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.DISCARD_ACCESS],
        mutationFn: payload => httpDiscardAccesses({payload}),
        onSuccess: async (data, variables, context) => {
            invalidateAccessesTableOnly(queryClient)
            variables.accessIds.forEach(accessId =>
                updateAccessStatusInSignatureSheetsCache(queryClient, accessId, 'discarded')
            )
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            await options?.onSuccess?.(data, variables, context)
        }
    })
}
